import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
      {
        path: '/',
        alias: ['/index.html', '/index.shtml', '/indexs.html'],
        name: 'index',
        component: () => import('../pages/index'),
        meta: {
          header: 1,
          map: 1
        }
      },
      {
        path: '/cart',
        name: 'cart',
        component: () => import('../pages/cart')
      }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
            return {selector: to.hash}
        } else if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    }
})
export default router



// WEBPACK FOOTER //
// ./src/script/router.js